import { type CampaignEntry, useCampaigns } from '../api';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

const useCampaignsData = () => {
  const { watch } = useFormContext();
  const accountId = watch('accountId');
  const selectedCampaigns: string[] = watch('selectedCampaigns');
  const filterByName: string[] = watch('filterCampaignsByName');
  const selectedCampaignsOnly: boolean = watch('selectedCampaignsOnly');

  const { data: rows, isLoading } = useCampaigns({
    params: { accountId },
  });

  const gridRows = useMemo(() => {
    if (!rows?.length) return [];

    const previousSelectedRows = selectedCampaigns
      ?.map(campaignId => rows.find(r => r.id === campaignId))
      .filter((row): row is CampaignEntry => row !== undefined) ?? [];

    const filteredCurrentRows = filterByName?.length ? (
      rows?.filter(row => {
        const campaignNameLower = row.campaign_name?.toLowerCase() ?? '';
        return filterByName?.every(filter =>
          campaignNameLower?.includes(filter.toLowerCase()),
        );
      })
    ) : rows;

    const resultMap = new Map<string, CampaignEntry>();

    filteredCurrentRows?.forEach(row => {
      resultMap.set(row.campaign_id, row);
    });

    previousSelectedRows.forEach(row => {
      if (!resultMap.has(row.campaign_id)) {
        resultMap.set(row.campaign_id, row);
      }
    });

    return rows?.filter(row => resultMap.has(row.campaign_id))
      .filter(row => !selectedCampaignsOnly || selectedCampaigns.includes(row.campaign_id)) ?? [];
    
  }, [selectedCampaigns, selectedCampaignsOnly, rows, filterByName]);

  return {
    gridRows,
    isLoading,
  };
};

export default useCampaignsData;